import styled from '@emotion/styled';
import Missing from '@assets/svg/match/missing.svg';
import Attending from '@assets/svg/match/attending.svg';
import Late from '@assets/svg/match/late.svg';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';
import {AttendanceMap} from '@models/AttendanceType';
import {colors} from '@styles/colors';

const Icons = {
  unknown: null,
  attending: <Attending />,
  missing: <Missing />,
  late: <Late data-icon="late" />,
};

export const ListAttendanceIndicator = ({ type, isContrast, indicator }) => {
  const icon = Icons[AttendanceMap[type]];

  return <Wrapper>{type !== -1 ? (indicator? <SmallButton isContrast={isContrast}>{icon}</SmallButton>: "" ): null}</Wrapper>;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
`;

const SmallButton = styled.div<{ isContrast?:boolean}>`
  border: 1px solid ${props => props.isContrast? "transparent" : "transparent"};
  border-radius: 50%;
  background-color: ${colors.white};
  display: grid;
  place-content: center;
  width: 27px;
  height: 27px;

  ${mq(Devices.tablet)} {
    width: 26px;
    height: 26px;
  }

  svg {
    height: 15px;

    path{
      fill:${props => props.isContrast? "#000" : null};
    }

    &[data-icon='late'] {
      height: 17px;
      width: 17px;
    }

    ${mq(Devices.tablet)} {
      height: 15px;

      &[data-icon='late'] {
        height: 17px;
        width: 17px;
      }
    }
  }
`;

export default ListAttendanceIndicator;
